
// import { useLocation } from 'react-router-dom';
// import { useMemo } from 'react';

// export const getParams = (searchParams, not_null) => {
//     const urlSearchParams = new URLSearchParams(not_null ? searchParams : window.location.search)
//     const params = Object.fromEntries(urlSearchParams.entries())
//     return params;
// }


// /**
//  * Hook untuk mengambil query string sebagai object.
//  * @returns {Object} params - Object hasil dari URLSearchParams
//  */
// export const useQueryParams = () => {
//     const location = useLocation();

//     const params = useMemo(() => {
//         const searchParams = new URLSearchParams(location.search);
//         const result = {};

//         for (const [key, value] of searchParams.entries()) {
//             result[key] = value;
//         }

//         return result;
//     }, [location.search]);

//     return params;
// };


import { useLocation, useHistory } from 'react-router-dom';
import { useMemo, useCallback } from 'react';

/**
 * Ambil semua query params dari URL
 */
export const getParams = (searchParams, not_null) => {
    const urlSearchParams = new URLSearchParams(not_null ? searchParams : window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
};

/**
 * Hook untuk ambil query string sebagai object.
 */
export const useQueryParams = (location) => {
    const _location = location || useLocation();

    // console.log(_location)

    const params = useMemo(() => {
        const searchParams = new URLSearchParams(_location.search);
        const result = {};
        for (const [key, value] of searchParams.entries()) {
            result[key] = value;
        }
        return result;
    }, [_location.search]);

    return params;
};

/**
 * Helper umum untuk update query params di URL (tanpa reload halaman)
 * Bisa dipakai di luar komponen React.
 */
export const setQueryParams = (newParams = {}, replace = false) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    Object.keys(newParams).forEach((key) => {
        const value = newParams[key];
        if (value === undefined || value === null || value === '') {
            searchParams.delete(key);
        } else {
            searchParams.set(key, value);
        }
    });

    const newSearch = searchParams.toString();
    const newUrl = `${currentUrl.pathname}${newSearch ? `?${newSearch}` : ''}`;

    if (replace) {
        window.history.replaceState(null, '', newUrl);
    } else {
        window.history.pushState(null, '', newUrl);
    }

    // trigger event agar useLocation dapat update
    window.dispatchEvent(new PopStateEvent('popstate'));
};

/**
 * Hook React Router v5 untuk update query params
 * Gunakan ini di dalam komponen React.
 */
export const useSetQueryParams = () => {
    const history = useHistory();
    const location = useLocation();

    return useCallback(
        (newParams = {}, replace = false) => {
            const searchParams = new URLSearchParams(location.search);

            Object.entries(newParams).forEach(([key, value]) => {
                if (value === undefined || value === null || value === '') {
                    searchParams.delete(key);
                } else {
                    searchParams.set(key, value);
                }
            });

            const search = searchParams.toString();
            const newUrl = `${location.pathname}${search ? `?${search}` : ''}`;

            if (replace) {
                history.replace(newUrl);
            } else {
                history.push(newUrl);
            }
        },
        [history, location]
    );
};

